import { JobStats } from "../../types";
import { JobStatsResponse } from "../controllers/jobs";

export const convertJobStatsResponse = (
    jobStatsResponse: JobStatsResponse
): JobStats => {
    const result: JobStats = {
        avgFirstHireTimeInDays: jobStatsResponse.avgFirstHireTimeInDays,
        avgFirstSubmitTimeInDays: jobStatsResponse.avgFirstSubmitTimeInDays,
        avgTimeInSubmittedInDays: jobStatsResponse.avgTimeInSubmittedInDays,
        submittedToInterviewingPercentage:
            jobStatsResponse.submittedToInterviewingPercentage,
        interviewingToHiredPercentage:
            jobStatsResponse.interviewingToHiredPercentage,
        hiredToRejectedPercentage: jobStatsResponse.hiredToRejectedPercentage,
    };

    return result;
};
